import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

// Endpoint basado en la captura de Django REST Framework
export const baseURI = 'nominas/percepciones-incidencias-reloj-checador';

/**
 * GET Listado
 * @param {object} params - Usualmente { percepcion: id }
 */
export const getPercepcionesIncidenciasReloj = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Un registro específico
 * @param {number} id
 */
export const getPercepcionIncidenciaReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear
 * @param {object} values
 */
export const postPercepcionIncidenciaReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Editar
 * @param {number} id
 * @param {object} values
 */
export const patchPercepcionIncidenciaReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Eliminar
 * @param {number} id
 */
export const deletePercepcionIncidenciaReloj = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
